export const BZJD = [{
        id: '25',
        name: '万佛顶',
        position: {
            top: '6%',
            left: '32%'
        }
    },
    {
        id: '26',
        name: '金顶金佛',
        position: {
            top: '8%',
            left: '26%'
        }
    },
    {
        id: '27',
        name: '接引殿',
        position: {
            top: '15%',
            left: '41%'
        }
    },
    {
        id: '11',
        name: '星空营地',
        position: {
            top: '16%',
            left: '50.5%'
        }
    },
    {
        id: '8',
        name: '灵觉寺',
        position: {
            top: '16%',
            left: '46.5%'
        }
    },

    {
        id: '3',
        name: '华严顶',
        position: {
            top: '19%',
            left: '73%'
        }
    },
    {
        id: '2',
        name: '洗象池',
        position: {
            top: '22%',
            left: '60%'
        }
    },

    {
        id: '4',
        name: '仙峰寺',
        position: {
            top: '36%',
            left: '41%'
        }
    },
    {
        id: '10',
        name: '九老洞',
        position: {
            top: '39%',
            left: '37%'
        }
    },
    {
        id: '5',
        name: '九十九道拐',
        position: {
            top: '48%',
            left: '36%'
        }
    },
    {
        id: '6',
        name: '万年寺',
        position: {
            top: '50%',
            left: '85%'
        }
    },
    {
        id: '7',
        name: '生态猴区',
        position: {
            top: '50%',
            left: '55%'
        }
    },

    {
        id: '9',
        name: '初殿',
        position: {
            top: '32%',
            left: '80%'
        }
    },

    {
        id: '28',
        name: '息心所',
        position: {
            top: '42%',
            left: '84%'
        }
    },
    {
        id: '12',
        name: '洪椿坪',
        position: {
            top: '55%',
            left: '39%'
        }
    },
    {
        id: '13',
        name: '雷音寺',
        position: {
            top: '61%',
            left: '26%'
        }
    },
    {
        id: '14',
        name: '纯阳殿',
        position: {
            top: '61%',
            left: '34%'
        }
    },
    {
        id: '15',
        name: '一线天',
        position: {
            top: '59%',
            left: '58%'
        }
    },
    {
        id: '16',
        name: '清音阁',
        position: {
            top: '67%',
            left: '62.5%'
        }
    },
    {
        id: '17',
        name: '伏虎寺',
        position: {
            top: '68%',
            left: '20%'
        }
    },
    {
        id: '19',
        name: '神水阁',
        position: {
            top: '66%',
            left: '45%'
        }
    },
    {
        id: '18',
        name: '报国寺',
        position: {
            top: '69%',
            left: '30%'
        }
    },
    {
        id: '20',
        name: '名山起点',
        position: {
            top: '85%',
            left: '41%'
        }
    },
    {
        id: '21',
        name: '天下名山',
        position: {
            top: '81%',
            left: '30.5%'
        }
    },
    {
        id: '24',
        name: '云上剧场',
        position: {
            top: '91%',
            left: '45%'
        }
    },
    {
        id: '23',
        name: '数游峨眉',
        position: {
            top: '92%',
            left: '38%'
        }
    },
    {
        id: '22',
        name: '大佛禅院',
        position: {
            top: '93%',
            left: '31.5%'
        }
    }
];


// WEBPACK FOOTER //
// ./src/enum/BiaoZhiJingDian.js